/** Defaults and labels for admin sales period filters (daily / weekly / monthly / yearly). */

function pad2(n) {
  return String(n).padStart(2, "0");
}

export function toDateInputValue(date) {
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return "";
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

export function toMonthInputValue(date) {
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return "";
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}`;
}

export function toIsoWeekValue(date) {
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return "";
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + 4 - (d.getDay() || 7));
  const yearStart = new Date(d.getFullYear(), 0, 1);
  const weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  return `${d.getFullYear()}-W${pad2(weekNo)}`;
}

export function getDefaultPeriodAnchor(dateFilter) {
  const now = new Date();
  switch (dateFilter) {
    case "daily":
      return toDateInputValue(now);
    case "weekly":
      return toIsoWeekValue(now);
    case "monthly":
      return toMonthInputValue(now);
    case "annually":
      return String(now.getFullYear());
    default:
      return "";
  }
}

function parseIsoWeekStart(isoWeek) {
  const match = /^(\d{4})-W(\d{2})$/i.exec(String(isoWeek || "").trim());
  if (!match) return null;
  const year = parseInt(match[1], 10);
  const week = parseInt(match[2], 10);
  if (!Number.isFinite(year) || !Number.isFinite(week) || week < 1 || week > 53) return null;
  const jan4 = new Date(year, 0, 4);
  const day = jan4.getDay();
  const mondayOffset = day === 0 ? -6 : 1 - day;
  const monday = new Date(year, 0, 4 + mondayOffset + (week - 1) * 7);
  monday.setHours(0, 0, 0, 0);
  return monday;
}

const shortDate = (d) =>
  d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });

export function formatSalesPeriodLabel(dateFilter, periodAnchor, startDate, endDate) {
  if (dateFilter === "all") return "All time";
  if (dateFilter === "range") {
    if (startDate && endDate) return `${startDate} to ${endDate}`;
    return "Custom range";
  }
  if (!periodAnchor) {
    const fallbacks = {
      daily: "Select a day",
      weekly: "Select a week",
      monthly: "Select a month",
      annually: "Select a year",
    };
    return fallbacks[dateFilter] || dateFilter;
  }
  switch (dateFilter) {
    case "daily": {
      const d = new Date(periodAnchor);
      return Number.isNaN(d.getTime()) ? periodAnchor : shortDate(d);
    }
    case "weekly": {
      const start = parseIsoWeekStart(periodAnchor);
      if (!start) return periodAnchor;
      const end = new Date(start);
      end.setDate(start.getDate() + 6);
      return `${shortDate(start)} – ${shortDate(end)}`;
    }
    case "monthly": {
      const match = /^(\d{4})-(\d{2})$/.exec(periodAnchor);
      if (!match) return periodAnchor;
      const d = new Date(parseInt(match[1], 10), parseInt(match[2], 10) - 1, 1);
      return d.toLocaleDateString("en-GB", { month: "long", year: "numeric" });
    }
    case "annually":
      return periodAnchor;
    default:
      return periodAnchor;
  }
}

export function buildSalesYearOptions(yearsBack = 12) {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let y = currentYear; y >= currentYear - yearsBack; y -= 1) {
    years.push(y);
  }
  return years;
}
